/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Trust_TitleInputs */

const en_mk_team_trust_title = /** @type {(inputs: Mk_Team_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents do the work. You keep the decisions.`)
};

const id_mk_team_trust_title = /** @type {(inputs: Mk_Team_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent bekerja. Keputusan tetap milikmu.`)
};

/**
* | output |
* | --- |
* | "Agents do the work. You keep the decisions." |
*
* @param {Mk_Team_Trust_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_trust_title = /** @type {((inputs?: Mk_Team_Trust_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Trust_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_trust_title(inputs)
	return en_mk_team_trust_title(inputs)
});